import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/library/Icon";

import styles from "./DashboardLock.css";

export default function DashboardLock({ lock, className }) {
  if (!lock.locked_by) {
    return null;
  }

  return <Icon name="lock" className={classNames(styles.root, className)} />;
}

DashboardLock.propTypes = {
  lock: PropTypes.object,
  className: PropTypes.string,
};
